import React,{Component}from 'react';
import {  PanelGroup, Panel, Button, Alert ,Input,Whisper,Tooltip,Notification,ButtonToolbar,IconButton,Icon} from 'rsuite';
import ResultPanel from './resultDrawer';
// import Game from '../myBabylonjs/game';
import Player from '../myBabylonjs/player';
import {GeomodelAxios} from '../myBabylonjs/geomodeln';
import {baseUrl} from '../url';
import Rightsliderbar from './rightSliderBar';

const buttonStyle={
    borderBottomLeftRadius: '0px',
    borderTopLeftRadius: '0px',
    borderBottomRightRadius: '0PX',
    borderTopRightRadius: '0PX',
    border:0,
    //padding: '15px',
    //backgroundColor: '#e1e1e1',
    color: '#4e4e4e'
}
// const Stepstyles = {
//     //width: '130px',
//     top:'50%',
//     //marginTop: '-10px',
//     marginLeft: '-5%',
//     position:'fixed',
//     display: 'inline-table',
//     verticalAlign: 'top'
// };

const RESULT_BASE_URL = 'https://www.cdtracer.cn';

class MenuPanel extends Component {
    constructor(props){
        super(props);
        this.state={
            modelLoaded:false,
            drawLineLong:15,
            activeKey:"1",
            isdrawed: false,
            openResultPanel: false,
            modelname:"",
            modelType:"",
            modelInform:null,
            //game:null,
            player:null,
            geomodeln:null,
            step:0,
            resultImageUrl:null,

        }
        this.handleChange=this.handleChange.bind(this);
        //this.handleSelect=this.handleSelect.bind(this);
        this.handleClick=this.handleClick.bind(this);
    }
    handleResultImageUpdate = (value) => {
        const url = value ? new URL(value, RESULT_BASE_URL).href : null;
        this.setState({
            resultImageUrl: url
        });
    }
    componentDidMount(){
        // this.setState({
        //     game:new Game('renderCanvas')
        // });
       
    }
    
    genGeomodelsSelectBut=()=>{
        if(this.props.geomodelList==={} || this.props.geomodelList===undefined || this.props.geomodelList===[]){
            return <Button appearance="default">暂无地质模型</Button>;
        }
        // this.state.geomodelList.forEach(item=>{
        //     //console.log(item.fileId);
        // });
        if(this.props.modelLoaded===false){
            return <Button appearance="default" loading block>模型列表加载中</Button>
        }
        return (
    this.props.geomodelList.map((item,index) => {
            // return <GeoSelectButton 
            //     id={item.fileId}
            //     key={index}
            //     title = {item.title}
            //     onClick = {this.handleSelect4}
            // />
            return <Button 
                    block
                    onClick={this.handleSelect4}
                    key={index}
                    id = {item.fileId}
                    >
                    {item.title}
                    </Button>
        })
        );
    }
    handleChange(value){
        if (value >= 5 && value <= 15) {
            value = Math.trunc(value);
        }
        else if (value > 15){
            value = 15;
        }
        else if (value < 5) {
            value = 5;
        }
        else {
            alert("请输入正确的值")
        }
        this.setState({
            drawLineLong: value
        });
        //return (Alert.warning("电极距太低或者测线拉太长可能会导致卡顿",3000));
    }
    handleSelect4=(e)=>{
        this.props.game.disposeScene();
        //console.log(e.target.id);
        let id = e.target.id;
        let modelInform = this.props.geomodelList.filter(data=>{
            return data.fileId == id;
        });
        modelInform = modelInform[0]
        //console.log(modelInform);
        let fileType = modelInform.fileType
        this.setState({
            modelLoaded:true,
            activeKey:id,
            isdrawed:false,
            modelname:id,
            modelType:fileType,
            modelInform:modelInform,
            player:new Player(this.props.game, { onResultImage: this.handleResultImageUpdate }),  
            resultImageUrl:null,
        },()=>{
            //this.state.game.engine.displayLoadingUI();
            try {
                //var geomodelDATA = JSON.parse(localStorage.getItem(id));
                switch (this.state.modelType){
                    
                    case "GlbGeomodel":
                        this.loadGlbGeomodel(id);
                        break;
                    case "Geomodel":
                        this.getGeomodelDataFromDB(id)
                        break;
                }
                
            }
            catch(err){
                
            }
            Notification.open({
                title:"提醒",
                description:<div>鼠标滚轮可以放大缩小，<br/>按住鼠标左键旋转，<br/>按住鼠标右键平移</div>
            });
        });
    }

    handleSelectFakeGeo=()=>{
        this.props.game.disposeScene();
        var id = "9E5E608B-1245-45C8-8980-9CEBDAC03C26";
        this.setState({
            modelLoaded:true,
            activeKey:id,
            isdrawed:false,
            modelname:id,
            player:new Player(this.props.game, { onResultImage: this.handleResultImageUpdate }),
            resultImageUrl:null,
            
        });
        this.loadGlbGeomodel(id);
    }
    loadGlbGeomodel(id){
        this.setState({
            geomodeln : new GeomodelAxios(this.props.game,0,id,this.state.modelInform),
            step:1
        });
    }

    async getGeomodelDataFromDB(id){
        // let geomodelDATA = await this.state.game.dbHandler.geomodel.get({id: id})
        // console.log(id)
        // console.log(geomodelDATA)
        // this.setState({
        //     geomodeln : new GeomodelAxios(this.state.game,geomodelDATA,id),
        //     step:1
        // });
        let geomodelDATA = await this.props.db.geomodel.get({id: id})
        this.setState({
            geomodeln : new GeomodelAxios(this.props.game,geomodelDATA,id,this.state.modelInform),
            step:1
        });

    }
    
    handleClick(){
        //console.log(this.state.drawLineLong);
        if(this.state.player.isDrawing){
            alert("请先画完测线!!!");
            return;
        }
        if(this.state.player.isDrawed!==true){
            this.state.player.drawline2(this.state.drawLineLong);
            this.setState({
                isdrawed:true,
                step:2
            })
            return(
                Alert.info('请在模型上方放置测线起始点',5000)
            );
        }
        else{
            return(
                Alert.error('只能画一条测线!',5000)
            );
        }
        
    }
    redrawLine = () =>{
        if(this.state.player.isDrawed===false){
            alert("请先画完测线!!!");
            return;
        }
        this.setState({
            isdrawed:false,
            step:1
        });
        this.state.player.destoryAll();
        return(Alert.info('清除中,请稍等',5000));
    }
    showResultPanel = () => {
        this.setState({
            openResultPanel: !this.state.openResultPanel
        })
    }
    drawLine = () => {
        if(this.state.player.isGenProbe){
            if(this.state.player.rope.length!==0){
                alert("已存在测线，请先清除之前的再生成！");
                return ;
            }
            this.state.player.destoryMeshs(this.state.player.sign);
            //player.disposeObservers();
            this.state.player.genernateRope(this.state.player.Probe);
            //player.ArcCamera();
            //console.log("start: " + this.state.player.startpoint + " end: " +this.state.player.endpoint);
            this.setState({
                step:2
            });
        }
        else{
            alert("请等待测点计算完成后再生成曲线");
        }
    }
    //ABMN接线模拟
    enterMockScene = () =>{
        Alert.info('请点击红色电极进行连接',10000)
        this.state.player.disposeObserver();
        if(this.state.geomodeln.xray){
            this.state.geomodeln.normalDisplay();
        }
        if(this.state.player.dfy==null){
            this.state.player.genernateDFY(this.state.player.scene,this.state.player.Probe[0].position);
            this.state.player.matchlink(this.state.player.scene,this.state.player.dfy.eleall);
            this.state.player.myCameraAinmation(this.state.player.dfy.camPos,this.state.player.dfy.camTarget,10,-Math.PI/2,false);
        }
        else{
            this.state.player.myCameraAinmation(this.state.player.dfy.camPos,this.state.player.dfy.camTarget,10,-Math.PI/2,false);
            this.state.player.dfy.screen.disposeControlPad();
            this.state.player.matchlink(this.state.player.scene,this.state.player.dfy.eleall);
        }

        Notification.open({
            title:"提醒",
            description:<div>鼠标滚轮可以放大缩小，<br/>按住鼠标左键旋转，<br/>按住鼠标右键平移</div>
        });
    }

    //操作电法仪
    enterMockdfy = () => {
        Alert.info('请点击屏幕上的键盘进行操作',10000);
        this.state.player.disposeObserver();
        //console.log(player.dfy.screen.activeControlPad);
        if(this.state.player.dfy==null){
            this.state.player.genernateDFY(this.state.player.scene,this.state.player.Probe[0].position);
            this.state.player.myCameraAinmation(this.state.player.dfy.screen.camPos,this.state.player.dfy.screen.camTarget,10,-Math.PI/2,true);
            this.state.player.dfy.screen.activeControlPad2();
        }
        else{
            this.state.player.myCameraAinmation(this.state.player.dfy.screen.camPos,this.state.player.dfy.screen.camTarget,10,-Math.PI/2,true);
            this.state.player.dfy.screen.activeControlPad2();
        }   
        this.setState({
            step:3
        });
    }

    //播放测点测量动画
    playAlphaAnimation = () => {
        
        Alert.info('计算中，请稍等', 10000);
        this.state.player.disposeObserver();
        if(this.state.player.dfy!=null){
            this.state.player.dfy.screen.disposeControlPad();
        }
        this.state.geomodeln.xrayDisplay();
        this.handleResultImageUpdate(null);
        this.state.player.axiosColor(this.state.player.Probe, this.state.drawLineLong,this.state.geomodeln.size,this.state.player.distance,this.state.geomodeln.id);

        this.setState({
            step:4
        });
    }

    turnSliderBarChange=(value)=>{
        if(this.state.geomodeln==null)
            return
        this.state.player.camera.alpha=value;
    }

    turnButUp=()=>{
        if(this.state.geomodeln==null)
            return
        this.state.player.camera.alpha+=0.1;
    }

    turnButDown=()=>{
        if(this.state.geomodeln==null)
        return
        this.state.player.camera.alpha-=0.1;
    }

    upDownSliderBarChange=(value)=>{
        if(this.state.geomodeln==null)
            return
        this.state.player.camera.fov=value;
    }

    upDownButUp=()=>{
        if(this.state.geomodeln==null)
            return
        this.state.player.camera.fov+=0.1;
    }

    upDownButDown=()=>{
        if(this.state.geomodeln==null)
            return
        this.state.player.camera.fov-=0.1;
    }

    modelAlpha=(value)=>{
        if(this.state.geomodeln==null)
            return
        this.state.geomodeln.model.material.alpha = value/100;
    }

    render(){
        return(
            <div>
           {/*<Sidenav style={{ marginTop: 1 }} defaultOpenKeys={['1', '2']}> */}
          
           <PanelGroup accordion bordered defaultActiveKey={1} >
           
           <Panel header={<div><IconButton icon={<Icon icon="check" />} appearance={this.state.step>=1?"primary":"subtle"} circle size="xs" />①实验步骤一:地质模型</div>} eventKey={1}  >
                <ButtonToolbar>
                     {/**<Button  block onClick={this.handleSelect3} >模型3</Button>
                    <Button  block onClick={this.handleSelect4} >模型4</Button>
                    <Button block onClick={this.popupPassValue}>popup</Button> */}
                    {/* <Button block onClick={this.handleSelectFakeGeo}>水库大坝渗漏模型</Button> */}
                    <this.genGeomodelsSelectBut />
                    
                </ButtonToolbar>
                
                </Panel>
            <Panel header={<div><IconButton icon={<Icon icon="check" />} appearance={this.state.step>=2?"primary":"subtle"} circle size="xs" />②实验步骤二:测线布设</div>} eventKey={2}>
                
                <ButtonToolbar>
                <Whisper trigger="focus" speaker={<Tooltip>必要</Tooltip>}>
                        <Input id="drawlinedis"  style={{buttonStyle}} placeholder="输入电极距(大于0小于15)" onChange={this.handleChange}/>
                </Whisper>
                <Button
                    id="drawline"

                    block 
                    value={this.state.drawLineLong}
                    disabled={!this.state.modelLoaded}
                    onClick={this.handleClick}
                    >
                        开始画线
                </Button>
                    
                <Button id="redraw"

                    block 
                    disabled={!this.state.isdrawed}
                    onClick={this.redrawLine}
                >
                    清除测线
                </Button>
                </ButtonToolbar>
            </Panel>
            <Panel header={<div><IconButton icon={<Icon icon="check" />} appearance={this.state.step>=3?"primary":"subtle"} circle size="xs" />③实验步骤三:仪器设置</div>} eventKey={3}>
                
            <Button
                id="EnterMockScene"
         
                block 
                disabled={!this.state.isdrawed}
                onClick={this.enterMockScene}
                >
                ABMN接线连接
            </Button>
            <Button
                id="EnterMockdfy"
     
                block 
                disabled={!this.state.isdrawed}
                onClick={this.enterMockdfy}
                >
                测量参数设置
            </Button>
            
            </Panel>
            <Panel header={<div><IconButton icon={<Icon icon="check" />} appearance={this.state.step===4?"primary":"subtle"} circle size="xs" />④实验步骤四:测量数据</div>} eventKey={4}>
               
                    <Button
                        id="PlayAlphaAnimation"
                        block
                        disabled={!this.state.isdrawed}
                        onClick={this.playAlphaAnimation}
                    >
                        测量,播放测点测量动画
                    </Button>
                    <Button
                        block
                        disabled={this.state.step!==4}
                        href={this.state.step>=4?baseUrl+"/api/Merm/"+this.state.player.id:""}
                        
                    >
                        下载测量数据
                    </Button>
                    <Button
                        block
                        disabled={this.state.step!==4}
                        onClick={this.showResultPanel}
                    >
                        显示测量结果图片
                    </Button>
                </Panel>
                <ResultPanel show={this.state.openResultPanel} link={this.state.resultImageUrl || "assets/pic/result.png"}>
                    {/**<Button href="/assets/dat/model2-Res2dInv.dat" appearance="primary">下载Res2dlnv文件</Button>*/}
                    <Button onClick={this.showResultPanel} style={{}} appearance="primary">收起</Button>
                </ResultPanel>
            {/* </Sidenav> */}
            </PanelGroup>
                
                
               
            
            <Rightsliderbar 
                modelAlpha={this.modelAlpha}
                turnButUp={this.turnButUp}
                turnSliderBarChange={this.turnSliderBarChange}
                turnButDown={this.turnButDown}
                upDownButUp={this.upDownButUp}
                upDownSliderBarChange={this.upDownSliderBarChange}
                upDownButDown={this.upDownButDown}
                />
            </div>
        )
    }
}
export default MenuPanel;